import 'reflect-metadata';
import { container } from 'tsyringe';
import { SaveCustomer } from './saveCustomer';
export const DependencyInjectorCustomersInfrastructure = () => {
    container.register("iSaveCustomer", { useClass: SaveCustomer });
};
export default DependencyInjectorCustomersInfrastructure;
